import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import getTimestamp from 'utils/getTimestamp'



const SiteSchedulesRunList = ({ expression }) => {
  if (!expression) {
    return null
  }

  let showRuns = 3
  let nextRunsList = []

  do {
    const { value, done } = expression.next()

    nextRunsList.push(getTimestamp(value))
    if (done) {
      break
    }
  } while (nextRunsList.length < showRuns)

  return (
    <div className="SiteSchedulesRunList">
      <h2 className="h5">
        Next 3 runs are:
      </h2>
      <ul className="list-group">
        { nextRunsList.map(runDate => (
          <li key={runDate} className="list-group-item">
            { moment(runDate).format('MMMM Do YYYY, h:mm:ss a') }
          </li>
        )) }
      </ul>
    </div>
  )
}

SiteSchedulesRunList.propTypes = {
  expression: PropTypes.shape({
    next: PropTypes.func.isRequired
  }),
  nextRun: PropTypes.number
}

export default SiteSchedulesRunList



// WEBPACK FOOTER //
// ./src/components/sites/schedules/site-schedule-run-list.js